<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px" :rules="rules">
				<el-row>
					<el-col :span="24">
						<el-form-item label="我的班级" prop="classname">

							<el-select v-model="formParameter.cid" :clearable="true" :filterable="true"
								placeholder="请选择班级/可搜索" @change="chgClzz()">
								<el-option v-for="item in listClass" :key="item.name" :label="item.name" :value="item.id">
								</el-option>
							</el-select>

						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="4">
					 <el-form-item label="学生名字" prop="sname">
						<el-checkbox v-model="checked" @change="selectAll">全选</el-checkbox>
					 </el-form-item>
					</el-col>
					<el-col :span="20">
							<el-select v-model="formParameter.sname" :clearable="true" :filterable="true" multiple
								placeholder="请选择学生/可搜索" @change="changeSelect">
								<el-option v-for="item in listStu" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="老师" prop="tname">
							<el-input v-if="formParameter.tname != null" v-model="listUser.value" disabled
								autocomplete="off"></el-input>
							<el-input v-if="formParameter.tname == null" v-model="listUser.value" disabled
								autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="通知类型" prop="thejobtype">
							<select-option-dictionary v-model="formParameter.thejobtype" dkey="tuis_type" :multiple="false"
								:stringMode="true"></select-option-dictionary>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="内容" prop="content">
							<el-input type="formParameter.content" :rows="2" placeholder="请输入内容<20字"
								v-model="formParameter.content">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">仅发送</el-button>
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm2()">发 送 + 推 送</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/study/tuisongzuoye/tuisongzuoye.js';
import classApi from '@/api/edu/clazz/clazz.js'
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			listClass: [],
			clzIdx:0,
			listStu: [],
			listStu2: [],
			listUser: [],
			checked: false,
			parameter: {},
			formParameter: { sname: [] },
			 
			value: '',
			rules: {
				//学生名字
				sid: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//老师名字
				tid: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 32,
						trigger: 'blur'
					}
				],
				//内容
				content: [
					{
						validator: this.$validate.required,
						trigger: 'blur'
					},
					{
						validator: this.$validate.length,
						max: 20,
						trigger: 'blur'
					}
				],
			}
		};
	},
	methods: {
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.disabled = disabled;
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//班级选择
		chgClzz( ) {
		 
			api.listStuid({ id: this.formParameter.cid }, (res) => {
				if (res.data.length > 0) {
					this.listStu = res.data;
				} else {
					this.listStu = [];
					this.checked = false;
				}
			});
			api.intnTcr({ cid: this.formParameter.cid }, (res) => {
				this.listUser = res.data[0];
				delete this.formParameter.sname;
			});
		},
		//学生选择
		changeSelect(val) {
			this.listStu2 = [];
			if (val.length === this.listStu.length) {
				this.checked = true;
			} else {
				this.checked = false;
			}

			this.listStu2 = val;

		},
		//学生全选
		selectAll() {
			this.formParameter.sname = [];
			this.listStu2 = [];
			if (this.checked) {
				for (let i = 0; i < this.listStu.length; i++) {
					this.formParameter.sname.push(this.listStu[i].name);
					this.listStu2.push(this.listStu[i].id)
				}
			} else {
				this.formParameter.sname = [];
			}
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		},
		//单独提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameters = [];

					for (var i = 0; i < this.listStu2.length; i++) {
						this.formParameter.sid = this.listStu2[i];
						this.formParameter.whethertopush = 1;
						this.formParameter.tid = this.listUser.id;
						let parameter = this.$utils.merger(this.formParameter);
						parameters.push(parameter);
					}
					api.save(parameters,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameterss = [];
					console.log(this.listStu2);
					this.formParameter.sid = this.listStu2[0].id;
					let parametera = this.$utils.merger(this.formParameter);
					api.update(parametera,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		//提交表单
		confirm2() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;
				if (!this.parameter.id) {
					//添加
					let parameters = [];
					console.log(this.listStu2);
					for (var i = 0; i < this.listStu2.length; i++) {
						this.formParameter.sid = this.listStu2[i];
						this.formParameter.tid = this.listUser.id;
						delete this.formParameter.sname
						let parameter = this.$utils.merger(this.formParameter);
						parameters.push(parameter);
					}
					api.save2push(parameters,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				} else {
					//编辑
					let parameterss = [];

					this.formParameter.sid = this.listStu2[0].id;
					let parametera = this.$utils.merger(this.formParameter);
					api.update(parametera,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list();
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
					);
				}
			});
		},
		init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};
			//清楚校验
			this.$refs.form.clearValidate();
			classApi.list3({}, (response) => {
				//reset
				this.listClass = [];
				this.listStu = [];
				this.listUser = [];
				this.checked = false;

				this.listClass = response.data;

			});
			if (this.parameter.id) {
				//编辑查询数据
				let parameter = {
					id: this.parameter.id
				};
				api.toUpdate(parameter, response => {
					console.log(response.data)
					this.formParameter = response.data;
					this.listUser.value = this.formParameter.tname;
					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
